<template>
  <div class="f-ml-7">
    <input
      type="checkbox"
      class="fapi-form-base-input-checkbox f-form-checkbox f-w-4 f-h-4 f-rounded f-border-gray-400 focus:f-ring-2 f--ml-7 f--mt-0.5"
      :id="id"
      :checked="value"
      :disabled="disabled"
      :name="name"
      :value="inputValue"
      v-bind="$attrs"
      @change="$emit('input', $event.target.checked)"
    />
    <label class="f-ml-2" :for="id">
      <slot />
    </label>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "BaseCheckbox",

  props: {
    id: {
      type: String,
      default: function () {
        return "checkbox-id-" + this.uid;
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: function () {
        return "checkbox-name-" + this.uid;
      },
    },
    inputValue: {
      default: true,
    },
  },
});
</script>
